/// <reference path="../../../../../typings/index.d.ts" />
/// <reference path="../../../components/baseClasses/dataMaintenanceSectionBase.ts" />

module Meevo.Plugins.MarketPricing {
    "use strict";
    import IPagerModel = Meevo.Plugins.MarketPricing.IPagerModel;

    export class GiftCardTypesSection extends Meevo.Components.BaseClasses.DataMaintenanceSectionBase<IPagerModel> {
        public filter: any;
        public isPreviewMassUpdate: boolean = false;
        public amount: any;
        public massUpdateCriteria: any = {
            increase: false,
            amount: 0,
            isPercent: false,
            isPrice: false,
        };
        protected modalService: Meevo.Components.Modal.IModalService;

        constructor(protected params: Meevo.Model.ISectionParamsBaseDataService) {

            super(params.sectionId,
                params.displayNameContentKey,
                params.template,
                params.isPrimarySection,
                params.handlesOwnCrud,
                params.baseEndpoint,
                params.sectionEndpoint,
                params.loggingService,
                params.dataService,
                params.identityService,
                params.noun,
                params.appSettings,
                params.sectionSecurityKey
            );

        }

        /**
         * Base class override which defines what a DEFAULT model looks like.
         */
        createSectionModelInstance(postAdd: (data: any) => any): void {

            this.postCancel();
            this.takeBackup();
        }

        /**
         * When tab is activated
         * */
        public sectionModelRetrieved(): void {
            this.isPreviewMassUpdate = false;

            this.filter = {
                types: [
                    {
                        id: null,
                        displayName: "LABEL_BOTH"
                    },
                    {
                        id: true,
                        displayName: "LABEL_PRICE"
                    },
                    {
                        id: false,
                        displayName: "LABEL_VALUE"
                    },
                ],
                sort: [
                    {
                        id: true,
                        displayName: "LABEL_INCREASE"
                    },
                    {
                        id: false,
                        displayName: "LABEL_DECREASE"
                    },
                ]

            };

            this.postCancel();
        }

        public prevUnselected(): void {
            this.sectionEndpoint = '';

            super.prevUnselected();
        }

        public defaultCriteria(): any {
            return {
                priceGroupId: this.parentItemId,
            }
        }

        public postCancel(): void {
            this.isPreviewMassUpdate = false;

            // set select element to default value from ng-selected
            this.massUpdateCriteria.increase = 'unexisting value';
            this.massUpdateCriteria.isPrice = 'unexisting value';

            this.amount = 0;
            this.massUpdateCriteria.amount = 0;
            this.massUpdateCriteria.isPercent = false;
        }

        /**
         * Save
         * */
        public preSave(): any {
            this.sectionEndpoint = 'GiftCardType';

            if (this.isPreviewMassUpdate) {

                // Create object for save Mass update
                this.model = <IPagerModel>{
                    increase: this.massUpdateCriteria.increase,
                    amount: this.massUpdateCriteria.isPercent ? this.amount * 100 : this.amount,
                    isPercent: this.massUpdateCriteria.isPercent,
                    isPrice: this.massUpdateCriteria.isPrice,
                }
            } else {
                let currentPage = this.model.pages[this.model.currentPage];
                let originalEntity = this.originalEntity;
                let originalCurrentPage = originalEntity.pages[this.model.currentPage];
                let save = {
                    models: []
                };

                // Find changed items
                _.each(currentPage, (element: any, index) => {
                    if (element.defaultPrice !== originalCurrentPage[index].defaultPrice || element.valuePrice !== originalCurrentPage[index].valuePrice) {
                        let isPrice = null;

                        if (element.valuePrice !== originalCurrentPage[index].valuePrice) {
                            isPrice = false;
                            element.oldValuePrice = originalCurrentPage[index].valuePrice;
                        } else if (element.defaultPrice !== originalCurrentPage[index].defaultPrice) {
                            isPrice = true;
                            element.oldDefaultPrice = originalCurrentPage[index].defaultPrice;
                        }

                        element.name = element.displayName;
                        element.isPrice = isPrice;

                        save.models.push(element);
                    }
                });

                this.model = <IPagerModel>save;
            }
        }
    }
}